'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "eventKey"],
  _excluded2 = ["targetCell"];
import PropTypes from 'prop-types';
import { useState, useCallback, useEffect, useRef } from 'react';
import UIAbstractFloaty from 'UIComponents/tooltip/UIAbstractFloaty';
import TableCellFloatyPopoverBody from 'rich-text-lib/components/table/TableCellFloatyPopoverBody';
import { getTableCellMergeSplitProperties } from '../hstable2/util';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  editor: PropTypes.object.isRequired,
  eventKey: PropTypes.string.isRequired
};
function TableCellPopoverManager(props) {
  const {
      editor,
      eventKey
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [target, setTarget] = useState(null);
  const [cellProperties, setCellProperties] = useState({});
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
    }
  }, []);
  useEffect(() => {
    const handleNodeChange = ({
      element: tableCellNodes
    }) => {
      if (!tableCellNodes) {
        handleRemove();
        return;
      }
      const _getTableCellMergeSpl = getTableCellMergeSplitProperties(editor, tableCellNodes),
        {
          targetCell
        } = _getTableCellMergeSpl,
        restCellProperties = _objectWithoutPropertiesLoose(_getTableCellMergeSpl, _excluded2);
      if (lastTarget.current !== targetCell) {
        setTarget(null);
        setTarget(targetCell);
      }
      setCellProperties(restCellProperties);
    };
    editor.on(`hsNodeChange:${eventKey}`, handleNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleNodeChange);
  }, [editor, eventKey, handleRemove]);
  if (!target) return null;
  return /*#__PURE__*/_jsx(UIAbstractFloaty, {
    "data-test-id": "table-cell-popover",
    layerClassName: "mce-hubspot-floaty",
    target: target,
    content: /*#__PURE__*/_jsx(TableCellFloatyPopoverBody, Object.assign({
      className: "mce-table-cell-popover",
      dropdownClassName: "mce-table-cell-dropdown"
    }, rest, cellProperties)),
    computePosition: ({
      targetBounds,
      contentDimensions
    }) => {
      return {
        top: targetBounds.top,
        left: targetBounds.right - contentDimensions.width - 1
      };
    }
  });
}
TableCellPopoverManager.propTypes = propTypes;
export default TableCellPopoverManager;